import { render, staticRenderFns } from "./manage-details.vue?vue&type=template&id=bbddf336&scoped=true&"
import script from "./manage-details.vue?vue&type=script&lang=js&"
export * from "./manage-details.vue?vue&type=script&lang=js&"
import style0 from "./manage-details.vue?vue&type=style&index=0&id=bbddf336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbddf336",
  null
  
)

export default component.exports